<template>
  <div class="upload-status-body">
    <div class="upload-status-body__labels">
      <span class="upload-status-body__label">
        {{ $t('userUpload.SYNC_UPLOADING_USERS') }}
      </span>
      <span class="upload-status-body__percentage">{{ percentage }}%</span>
    </div>
    <AttensiProgressBar theme="portal-blue" :value="percentage" />
  </div>
</template>

<script setup lang="ts">
import { AttensiProgressBar } from '@attensi/materia'
import { computed } from 'vue'

const props = defineProps<{
  completedBatches: number
  numberOfBatches: number
}>()

const percentage = computed(() => {
  if (!props.numberOfBatches) return 0
  return Math.round((props.completedBatches / props.numberOfBatches) * 100)
})
</script>

<style lang="scss" scoped>
.upload-status-body {
  &__labels {
    display: flex;
    justify-content: space-between;
    margin-bottom: $spacing-4xs;
  }

  &__label {
    font-size: $font-size-m;
    font-weight: 700;
    color: $color-text;
  }

  &__percentage {
    font-size: $font-size-m;
    font-weight: 700;
    color: $color-blue-45;
  }
}
</style>
